// Inlined at build time by Next.js. Must be provided to `next build`.
export const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "";
